import React, { useRef, useEffect } from 'react';
import { StyleSheet, Animated } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface SkeletonCardProps {
  height?: number;
  width?: number | string;
  style?: any;
}

export default function SkeletonCard({ 
  height = 120, 
  width = '100%', 
  style 
}: SkeletonCardProps) {
  const { colors } = useTheme();
  const animatedValue = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: false,
        }),
        Animated.timing(animatedValue, {
          toValue: 0,
          duration: 1000,
          useNativeDriver: false,
        }),
      ])
    );
    animation.start();

    return () => animation.stop();
  }, [animatedValue]);

  const opacity = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0.3, 0.7],
  });

  return (
    <Animated.View 
      style={[
        styles.skeleton,
        {
          height,
          width,
          backgroundColor: colors.border,
          opacity,
        },
        style
      ]} 
    />
  );
}

const styles = StyleSheet.create({
  skeleton: {
    borderRadius: 12,
    marginBottom: 12,
  },
}); 